import { SensorType } from "common";
import { useHVACFilterStatus } from "common/src/hooks/useHVACFilterStatus";
import { useTranslation } from "react-i18next";
import { Token, getTokenValue } from "tamagui";

import { useLatestSensorEvents } from "../sensors/useLatestSensorEvents";

export type HVACFilterStatus = {
  value: number;
  label: string;
  color: string;
};

export interface HVACFilterStatusResult {
  data: HVACFilterStatus | null;
  loading: boolean;
  error: Error | null;
}

export const useGetHVACFilterStatus = (): HVACFilterStatusResult => {
  const { event } = useLatestSensorEvents(SensorType.HVAC_AIRHANDLER_MONITOR);
  const { t } = useTranslation();

  const sensorId = event?.sensorId;

  const {
    data: filterStatusData,
    loading,
    error,
  } = useHVACFilterStatus(sensorId);

  try {
    const data = filterStatusData
      ? {
          value: filterStatusData.filterHealthPercentage || 0,
          label: t("hvac.main"),
          color: getColorForFilterStatus(filterStatusData.status),
        }
      : null;

    return {
      data,
      loading,
      error,
    };
  } catch (err) {
    return {
      data: null,
      loading,
      error: err instanceof Error ? err : new Error("Unknown error"),
    };
  }
};

const getColorForFilterStatus = (status: string) => {
  switch (status) {
    case "Good":
      return getTokenValue("$successGreen" as Token, "color");
    case "Poor":
      return getTokenValue("$warning" as Token, "color");
    case "Error":
      return getTokenValue("$error" as Token, "color");
    default:
      return getTokenValue("$successGreen" as Token, "color");
  }
};
